module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (!_vm.loading) ? _c('div', [(_vm.fullMode) ? _c('div', [(_vm.loggedIn) ? _c('div', [_c('div', [_c('el-container', [(!_vm.isPrintMode) ? _c('el-aside', {
    attrs: {
      "width": "200px"
    }
  }, [_c('el-menu', {
    staticClass: "el-menu--vertical",
    attrs: {
      "background-color": "#545c64",
      "text-color": "#fff",
      "active-text-color": "#09b3af"
    }
  }, [_c('el-menu-item', {
    attrs: {
      "index": "1"
    },
    on: {
      "click": function($event) {
        return _vm.navigateToReports()
      }
    }
  }, [_c('img', {
    staticClass: "logo",
    attrs: {
      "src": "/static/netural_logo.svg"
    }
  })]), _vm._v(" "), (_vm.hasUserRolePermission('sales')) ? _c('el-menu-item', {
    attrs: {
      "index": "2"
    },
    on: {
      "click": function($event) {
        return _vm.sidebarClick(509644)
      }
    }
  }, [_vm._v("\n                                Sales\n                            ")]) : _vm._e(), _vm._v(" "), (_vm.hasUserRolePermission('catalogue')) ? _c('el-menu-item', {
    attrs: {
      "index": "3"
    },
    on: {
      "click": function($event) {
        return _vm.sidebarClick(509643)
      }
    }
  }, [_vm._v("\n                                Catalogue\n                            ")]) : _vm._e(), _vm._v(" "), (
    _vm.isVisible &&
    _vm.hasUserRolePermission('contents')
  ) ? _c('el-menu-item', {
    attrs: {
      "index": "4"
    },
    on: {
      "click": function($event) {
        return _vm.sidebarContentsClick()
      }
    }
  }, [_vm._v("\n                                Contents\n                            ")]) : _vm._e(), _vm._v(" "), (
    _vm.hasUserRolePermission('configuration')
  ) ? _c('el-menu-item', {
    attrs: {
      "index": "5"
    },
    on: {
      "click": function($event) {
        return _vm.sidebarClick(509645)
      }
    }
  }, [_vm._v("\n                                Configuration\n                            ")]) : _vm._e(), _vm._v(" "), (_vm.isVisible && !_vm.isRestricted('report') && !_vm.isRestricted('customer_registrations')) ? _c('el-submenu', {
    attrs: {
      "index": "6"
    }
  }, [_c('template', {
    slot: "title"
  }, [_vm._v("Statistics")]), _vm._v(" "), _c('el-menu-item', {
    attrs: {
      "index": "6-1"
    },
    on: {
      "click": function($event) {
        return _vm.navigateToStatistics()
      }
    }
  }, [_vm._v("\n                                    Reports\n                                ")]), _vm._v(" "), _c('el-menu-item', {
    attrs: {
      "index": "6-2"
    },
    on: {
      "click": function($event) {
        return _vm.navigateToCustomerRegistrations()
      }
    }
  }, [_vm._v("\n                                    Registrations\n                                ")])], 2) : _vm._e(), _vm._v(" "), (
    _vm.hasUserRolePermission(
      'coupons_customer_support'
    ) && _vm.isCustomerSupport()
  ) ? _c('el-menu-item', {
    attrs: {
      "index": "7"
    },
    on: {
      "click": function($event) {
        return _vm.sidebarClick(523060705)
      }
    }
  }, [_vm._v("\n                                Coupon\n                            ")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "el-menu__logout"
  }, [_c('el-button', {
    staticClass: "el-menu__logout-button",
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.onLogout()
      }
    }
  }, [_vm._v("Logout")])], 1)], 1)], 1) : _vm._e(), _vm._v(" "), _c('el-main', [(!_vm.isPrintMode) ? _c('el-menu', {
    attrs: {
      "default-active": "1",
      "mode": "horizontal"
    },
    on: {
      "select": _vm.handleSelect
    }
  }, [_vm._l((_vm.getVisibleTabItems(
    _vm.config.body
  )), function(nav, index) {
    return [(
      _vm.hasUserRolePermission(
        nav.route.toLowerCase()
      ) &&
      !_vm.isRestricted(
        nav.route.toLowerCase()
      ) &&
      !_vm.isCustomerSupport()
    ) ? _c('el-menu-item', {
      key: index,
      attrs: {
        "index": nav.route
      }
    }, [_c('span', [_vm._v(_vm._s(nav.name))])]) : _vm._e()]
  })], 2) : _vm._e(), _vm._v(" "), (_vm.activeConfig != null) ? _c('div', {
    class: {
      container: _vm.config.body.length
    }
  }, [_c(_vm.activeConfig.component, {
    tag: "div",
    attrs: {
      "model": _vm.model,
      "action": _vm.action,
      "id": _vm.id,
      "root-config": _vm.config,
      "config": _vm.activeConfig,
      "site-id": _vm.login.site_id,
      "permitted-sites-config": _vm.permittedSitesConfig
    }
  })], 1) : _vm._e()], 1)], 1)], 1)]) : _c('div', [_c('el-container', [_c('el-main', {
    staticClass: "login__container"
  }, [_c('el-form', {
    ref: "login",
    staticClass: "login",
    attrs: {
      "model": _vm.login,
      "status-icon": "",
      "label-width": "120px"
    },
    nativeOn: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.submitForm.apply(null, arguments)
      }
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Shop ID",
      "prop": "site_id"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "site_id"
    },
    model: {
      value: (_vm.login.site_id),
      callback: function($$v) {
        _vm.$set(_vm.login, "site_id", $$v)
      },
      expression: "login.site_id"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Email",
      "prop": "email"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "email"
    },
    model: {
      value: (_vm.login.email),
      callback: function($$v) {
        _vm.$set(_vm.login, "email", $$v)
      },
      expression: "login.email"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Password",
      "prop": "password"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "password"
    },
    model: {
      value: (_vm.login.password),
      callback: function($$v) {
        _vm.$set(_vm.login, "password", $$v)
      },
      expression: "login.password"
    }
  })], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "native-type": "submit",
      "type": "primary"
    }
  }, [_vm._v("Login")])], 1)], 1)], 1)], 1)], 1)]) : _c('div', [_c('el-menu', {
    attrs: {
      "default-active": "1",
      "mode": "horizontal"
    },
    on: {
      "select": _vm.handleSelect
    }
  }, [_vm._l((_vm.getVisibleTabItems(_vm.config.body)), function(nav, index) {
    return [(
      _vm.hasUserRolePermission(nav.route.toLowerCase()) &&
      !_vm.isRestricted(nav.route.toLowerCase())
    ) ? _c('el-menu-item', {
      key: index,
      attrs: {
        "index": nav.route
      }
    }, [_c('span', [_vm._v(_vm._s(nav.name))])]) : _vm._e()]
  })], 2), _vm._v(" "), (_vm.activeConfig != null) ? _c('div', {
    staticClass: "container"
  }, [_c(_vm.activeConfig.component, {
    tag: "div",
    attrs: {
      "model": _vm.model,
      "action": _vm.action,
      "id": _vm.id,
      "root-config": _vm.config,
      "config": _vm.activeConfig
    }
  })], 1) : _vm._e()], 1)]) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7d400cac"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Admin.vue
// module id = 548
// module chunks = 1